import { useMediaQuery } from 'react-responsive';

import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PopupToBottomSheet from '@/shared-components/popups/components/PopupToBottomSheet';
import Text from '@/shared-components/text/components/Text';

import Search from './search';

import './index.css';

export default function AddArtworks({ open, close, selectedArtworks, setSelectedArtworks, maxSelectedArtworks = 5 }) {
  const isMobile = useMediaQuery({ query: '(max-width: 800px)' });
  const t = useTranslations('common.profile.pages.artlist');

  return (
    <>
      <PopupToBottomSheet 
        className="artlist-add-artworks-popup-bottom-sheet__container" 
        open={open} 
        close={close} 
        popupOptions={{ opacity: true }}
        forcePopup={isMobile}
      >
        <div className="artlist-add-artworks__content-container">
          <div className="artlist-add-artworks__header">
            <Text className="artlist-add-artworks__header-text">
              {t('add_artworks.popup.title')}
            </Text>

            <XIcon className="artlist-add-artworks__close-button" onClick={close}/>
          </div>

          <Search 
            selectedArtworks={selectedArtworks}
            setSelectedArtworks={setSelectedArtworks}
            maxSelectedArtworks={maxSelectedArtworks} 
          />
          
        </div>
      </PopupToBottomSheet>
    </>
  );
}
